import { StyleSystemProps } from '@withjoy/joykit';

type ToggleWrapperProps = { isChecked: boolean };

const toggleWrapper = ({ isChecked = false }: ToggleWrapperProps): StyleSystemProps => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 6,
  borderRadius: 2,
  gap: 5,
  borderStyle: 'solid',
  borderWidth: isChecked ? '2px' : '1px',
  borderColor: isChecked ? 'mono14' : 'mono3',
  background: 'white',
  marginBottom: 5
});

const appPlatFormToggleWrapper = (props: ToggleWrapperProps): StyleSystemProps => ({
  ...toggleWrapper(props),
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'center'
});

export const styles = {
  toggleWrapper,
  appPlatFormToggleWrapper
};
